// @flow
import { createContext } from 'react';

export const StreamGovernanceWorkloadContext = createContext({});
